module.exports = {
	"OceanDragon": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結來領取傳奇寵物和水晶!",
		"gift": "的禮物到囉！",
		"gift_no_name": "新玩家＆回鍋玩家通通有水晶禮物！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "*獎勵：1,000顆水晶 + 旋風青龍",
		"mission": "<strong>任務!</strong> 在逃出團區域1抵達Stage1-5!",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	},
	"2ndAnniversary": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結來領取傳奇寵物和水晶!",
		"gift": "的禮物到囉！",
		"gift_no_name": "新玩家＆回鍋玩家通通有水晶禮物！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "*獎勵：2,222顆水晶 + 旋風青龍",
		"mission": "<strong>任務!</strong> 在逃出團區域1抵達Stage1-5!",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	},
	"MoonLight": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結，領取傳奇餅乾與水晶! ",
		"gift": "的禮物到囉！",
		"gift_no_name": "新玩家＆回鍋玩家通通有水晶禮物！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "* 獎勵：1,000顆水晶 + 月光魔法師餅乾",
		"mission": "<strong>任務!</strong> 在逃出團區域1抵達Stage1-5!",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	},
	"FireSpirit": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結，領取傳奇餅乾與水晶! ",
		"gift": "的禮物到囉！",
		"gift_no_name": "新玩家＆回鍋玩家通通有水晶禮物！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "＊禮物：水晶1,000顆+火精靈餅乾",
		"mission": "<strong>任務</strong> 進入獎盃賽大廳！",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	},
	"RainbowCube": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結領取彩虹方塊&水晶！",
		"gift": "邀你一起玩《跑跑薑餅人：烤箱大逃亡》",
		"gift_no_name": "新玩家＆回鍋玩家通通有水晶禮物！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "* 禮物：水晶3,000顆+彩虹方塊1,000顆",
		"mission": "<strong>任務</strong> 進入獎盃賽大廳！",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	},
	"JellySkin": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結領取彩虹方塊&水晶！",
		"gift": "邀你一起玩《跑跑薑餅人：烤箱大逃亡》",
		"gift_no_name": "新玩家、回歸玩家都能獲得彩虹方塊和水晶唷！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "* 禮物：水晶3,000顆+彩虹方塊1,000顆",
		"mission": "<strong>任務</strong> 進入獎盃賽大廳！",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	},
	"Yeti": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結領取傳奇寵物&水晶！",
		"gift": "邀你一起玩《跑跑薑餅人：烤箱大逃亡》",
		"gift_no_name": "新玩家、回歸玩家都能獲得傳奇寵物和水晶唷！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "* 禮物：水晶1,000顆 + 暴風雪怪",
		"mission": "<strong>任務</strong> 進入獎盃賽大廳！",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	},
	"DreamCatcher": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結領取傳奇寵物&水晶！",
		"gift": "邀你一起玩《跑跑薑餅人：烤箱大逃亡》",
		"gift_no_name": "新玩家、回歸玩家都能獲得傳奇寵物和水晶唷！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "* 禮物：1,000顆水晶 + 星光捕夢網",
		"mission": "<strong>任務</strong> 進入獎盃賽大廳！",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	},
	"WaveDrop": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結領取傳奇寵物&水晶！",
		"gift": "邀你一起玩《跑跑薑餅人：烤箱大逃亡》",
		"gift_no_name": "新玩家、回歸玩家都能獲得傳奇寵物和水晶唷！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "* 禮物：1,000顆水晶 + 海浪滴露",
		"mission": "<strong>任務</strong> 進入獎盃賽大廳！",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	},
	"JellySkin02": {
		"title": "跑跑薑餅人：烤箱大逃亡",
		"description": "點擊連結領取水晶和宇宙甜甜圈！",
		"gift": "邀你一起玩《跑跑薑餅人：烤箱大逃亡》",
		"gift_no_name": "新玩家與回歸玩家都能獲得<br />宇宙甜甜圈、太空迷你球和水晶唷！",
		"download_now": "你還沒有玩《跑跑薑餅人：烤箱大逃亡》嗎？<br>快去下載吧！",
		"how_to_get_reward": "獎勵獲得方式",
		"install_cro": "安裝《跑跑薑餅人：烤箱大逃亡》",
		"claim_reward": "按下「領禮物去」按鈕",
		"rewards": "* 禮物：1,000顆水晶+宇宙甜甜圈X20+太空迷你球X20",
		"mission": "<strong>任務</strong> 進入獎盃賽大廳！",
		"condition": "僅限新玩家/回歸玩家才可獲得獎勵。",
		"new_player": "＊新玩家：邀請活動期間，首次加入跑跑薑餅人的玩家。",
		"old_player": "＊回歸玩家：30天以上未登入跑跑薑餅人的玩家再次回來遊戲。"
	}
};